import { withInstall } from '@jdesign-vue/utils'

import Affix from './src/affix.vue'

export const JdAffix = withInstall(Affix)
export default JdAffix

export * from './src/affix'
